import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { getProductsList } from '../../../../Desktop/Pages/ProductListing/Categories/Apis/productListingSlice'

export const withNonDigitalProductListingByCategory = (WrappedComponent) => {
	const WithNonDigitalProductListingByCategory = (props) => {
		const dispatch = useDispatch()
		const { categoryId } = useParams() // Extract categoryId from the route params
		const { products, productsCount } = useSelector((state) => state.productsListing)

		const location = useLocation()
		const { categoryId: mainCateogry, subCategoryId, selectedChildCat } = location.state || {}

		useEffect(() => {
			if (categoryId) {
				dispatch(getProductsList({ childCategoryId: categoryId })) // Fetch products when category changes
			}
		}, [categoryId])

		return (
			<WrappedComponent
				{...props}
				products={products}
				categoryId={categoryId}
				productsCount={productsCount}
				selectedChildCat={selectedChildCat}
			/>
		)
	}

	return WithNonDigitalProductListingByCategory
}
